module.exports = __webpack_public_path__ + "media/images/amenities_icons/massages-f44bdd1be5437b367325c3f055e54c77.svg";